// extracted by mini-css-extract-plugin
module.exports = {"breadcrumbs":"page-title-breadcrumbs__breadcrumbs___2_q78","breadcrumb":"page-title-breadcrumbs__breadcrumb___2kPSk","divider":"page-title-breadcrumbs__divider___dBJZk"};